import { apiCatalogs } from '@/api/apiCatalogs'
import { endpoints } from '@/api/endpoints'
import {
  CurrencyCatalogsDTO,
  CurrencyCatalogsParams,
  AboutCurrencyInBlockchainParams,
  AboutCurrencyInBlockchainDTO,
} from './currencyTypes'

async function fetchCurrencies(
  params: CurrencyCatalogsParams,
): Promise<{ currencies: CurrencyCatalogsDTO[] }> {
  const response = await apiCatalogs.get<{ currencies: CurrencyCatalogsDTO[] }>(
    endpoints.catalogs.currencies.getCurrencies,
    {
      params: { ...params },
    },
  )

  return response.data
}

async function getAboutCurrencyInBlockchain({
  currency_isin,
  blockchain_code,
}: AboutCurrencyInBlockchainParams): Promise<AboutCurrencyInBlockchainDTO> {
  const response = await apiCatalogs.get<AboutCurrencyInBlockchainDTO>(
    endpoints.catalogs.currencies.getCurrencyBlockchainInfos(
      currency_isin,
      blockchain_code,
    ),
  )

  return response.data
}

export const currencyApi = {
  fetchCurrencies,
  getAboutCurrencyInBlockchain,
}
